import React from 'react'
import { styled } from '@linaria/react'
import X from '../svgr/Twitter'
import Discord from '../svgr/Discord'
import Telegram from '../svgr/Telegram'
import Instagram from '../svgr/Instagram'

export const SocialLinks = ({ className }: { className?: string }) => {
  // FIXME: UPDATE ME
  return (
    <SocialLinksContainer className={className}>
      {[
        {
          id: 'x',
          icon: <X />,
          href: '',
        },
        {
          id: 'discord',
          icon: <Discord />,
          href: '',
        },

        {
          id: 'telegram',
          icon: <Telegram />,
          href: '',
        },

        {
          id: 'instagram',
          icon: <Instagram />,
          href: '',
        },
      ].map(({ id, icon, href }) => (
        <a key={id} href={href} target="_blank" rel="noopener noreferrer">
          {icon}
        </a>
      ))}
    </SocialLinksContainer>
  )
}

const SocialLinksContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 16px;
`
